import React from 'react'

import Reviews from '../Reviews';

import logo from '../../images/logo.png';
import logo_icon from '../../images/logo-icon.png';


export default class extends React.Component {

  render() {
    document.title = this.props.fullname+" van "+this.props.companyname+" + Peter van der Meer van Ghostin";
    let cmp = this.props.competition;
    return (
      <div>
        <div className="full big black">
          <div className="wrap content-block">
            <div style={{marginBottom:"6em"}}>
              <img src={logo} alt="Ghostin.nl" style={{maxWidth:"160px", marginRight:"12px"}} />
              <b>Exclusieve Strategie op maat</b>
            </div>

            <h2>{this.props.fullname}</h2>

            <div style={{textAlign:"center"}}>
              <img src={this.props.logo_target} alt={this.props.companyname} style={{maxWidth:"120px", marginTop:"-15px"}} />
              <b style={{fontSize:"3em", margin:"0 30px"}}>+</b>
              <img src={logo_icon} alt="Ghostin.nl" style={{maxWidth:"120px", marginTop:"-15px"}} />
            </div>

            <div className="col-2" style={{margin:"0 auto", display:"block", textAlign:"center"}}>
              <h3>LinkedIn Strategie voor {this.props.firstname} en het {this.props.companyname} team</h3>
              <img src={this.props.screenshot_target} alt={"LinkedIn "+this.props.fullname} style={{ maxWidth: "100%" }} />
              <h3>Het proces</h3>
              <p style={{ textAlign: "left", marginBottom: "2em" }}>Een kijkje van 161 seconden dat laat zien waarom CTO-klanten bij mij blijven, en een korte uitleg van het frictieloze proces dat voor een voorsprong in jouw branche zorgt. Zo kun je de strijd winnen met {cmp ? cmp : "jouw B2B concurrenten"}.</p>
              <div style={{ maxWidth: "100%", position: "relative", paddingBottom: "46.875%", height: "0" }}><iframe title="Waarom mijn klanten blijven" src="https://www.loom.com/embed/b3134d4701944c27a65113ecc3554445" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%"}}></iframe></div>
              <h3>Wil jij jouw persoonlijke blauwdruk bespreken?</h3>
              <p style={{ textAlign: "left", marginBottom: "2em" }}>Laten we 15 minuten plannen voor een persoonlijke "LinkedIn Diagnose" voor {this.props.companyname}. Geen pitch onder hoge druk, maar waardevol en strategisch inzicht.<br/><br/>Ik weet dat je een bedrijf te runnen hebt. Mijn proces vraagt slechts 30 minuten per twee weken, en af en toe jouw halfbakken notities doordeweeks. Ik doe het zware werk, jij bepaalt het verhaal.</p>
              <div><a href="https://calendar.app.google/XPw5Ho3npLVVWrSD9" target="_blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-gold">Plan 15 minuten in</a></div>
            </div>

          </div>
        </div>

        <Reviews limited />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/LetterLandingCTO.js